module.exports = __webpack_public_path__ + "static/img/12.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/12.png
// module id = 6HVE
// module chunks = 0